module.exports = __webpack_public_path__ + "static-portal/img/news14-3.db61f1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news14-3.png
// module id = L0Qp
// module chunks = 4